export const MAIL_INVALID_NAME = "mail invalid name"
export const MAIL_NO_CONTENT = "no content"
export const MAIL_CONTENT_TO_LONG = "content too long"
export const MAIL_INVALID_ADDRESS = "invalid address"